import type {NormalY, Resolution} from "#material-maps-exporter/core/types"
import type {Engine, Workflow} from "#material-maps-exporter/targets/pbr/types"

export function workflowToString(workflow: Workflow): string {
    switch (workflow) {
        case "metalnessRoughness":
            return "Metallness / Roughness"
        case "specularGlossiness":
            return "Specular / Glossiness"
    }
    return workflow
}

export function engineToString(engine: Engine): string {
    switch (engine) {
        case "cm":
            return "colormass"
        case "corona":
            return "Corona"
        case "vray":
            return "VRay"
        case "cycles":
            return "Cycles"
    }
    return engine
}

export function normalYToString(normalY: NormalY): string {
    switch (normalY) {
        case "default":
            return "Engine default"
        case "y+up":
            return "+Y up"
        case "y+down":
            return "+Y down"
    }
    return normalY
}

export function resolutionToString(resolution: Resolution): string {
    switch (resolution) {
        case "original":
            return "Original"
        case "dpi72":
            return "Low (72 DPI)"
    }
    return resolution
}
